import { useEffect, useState } from 'react';
import { Check, Save, Settings2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { api } from '../../api';
import { PageHeader, Surface } from '../../components/ui';

const SETTINGS = [{ key: 'max_bot_username', labelKey: 'adminSettings.keyMaxBotUsername', hintKey: 'adminSettings.hintMaxBotUsername', placeholder: 'id701000686310_bot' }];

export default function SettingsPage() {
  const { t } = useTranslation();
  const [values, setValues] = useState({});
  const [saving, setSaving] = useState({});
  const [saved, setSaved] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState('');

  useEffect(() => {
    api.getSettings().then((rows) => {
      const map = {};
      rows.forEach((row) => { map[row.key] = row.value ?? ''; });
      setValues(map);
    }).catch((err) => setLoadError(err.message)).finally(() => setLoading(false));
  }, []);

  const handleSave = async (key) => {
    setSaving((state) => ({ ...state, [key]: true }));
    setErrors((state) => ({ ...state, [key]: '' }));
    try {
      await api.updateSetting(key, values[key] ?? '');
      setSaved((state) => ({ ...state, [key]: true }));
      setTimeout(() => setSaved((state) => ({ ...state, [key]: false })), 2000);
    } catch (err) { setErrors((state) => ({ ...state, [key]: err.message })); }
    finally { setSaving((state) => ({ ...state, [key]: false })); }
  };

  return (
    <div className="page page-narrow">
      <PageHeader icon={Settings2} title={t('adminSettings.title')} subtitle={t('adminSettings.subtitle')} />
      {loadError && <div className="alert alert-danger" role="alert">{loadError}</div>}
      <Surface>
        <div className="surface-body">
          {loading ? <div className="text-muted">{t('adminSettings.loading')}</div> : SETTINGS.map(({ key, labelKey, hintKey, placeholder }) => (
            <div key={key}>
              <label className="form-label" htmlFor={`setting-${key}`}>{t(labelKey)}</label>
              <div className="d-flex gap-2 flex-column flex-sm-row">
                <input id={`setting-${key}`} className="form-control" placeholder={placeholder} value={values[key] ?? ''} onChange={(event) => setValues((state) => ({ ...state, [key]: event.target.value }))} onKeyDown={(event) => event.key === 'Enter' && handleSave(key)} />
                <button type="button" className="btn btn-primary" disabled={saving[key]} onClick={() => handleSave(key)}>
                  {saved[key] ? <Check className="icon" aria-hidden="true" /> : <Save className="icon" aria-hidden="true" />}
                  {saved[key] ? t('profile.saved') : saving[key] ? t('profile.saving') : t('adminSettings.save')}
                </button>
              </div>
              {errors[key] && <div className="text-danger small mt-2" role="alert">{errors[key]}</div>}
              <div className="form-text mt-2">{t(hintKey)}</div>
            </div>
          ))}
        </div>
      </Surface>
    </div>
  );
}
